module.exports = __webpack_public_path__ + "img/Tote_Person.78243ebf.svg";